export default "__VITE_ASSET__SjzsY$rs__"